import { atom } from 'jotai';
export const $I18nText = atom({});
//# sourceMappingURL=i18n-text.js.map